import React, { ChangeEvent, useState, useEffect } from 'react'
import { Product, ProductParameter, ProductParameterValue } from '../../../product'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import ExpandMore from '@material-ui/icons/ExpandMore'
import ExpandLess from '@material-ui/icons/ExpandLess'
import { connect } from 'react-redux'
import { ButtonCustomStyles } from './styles'

interface ProductBuilderParamInputProps {
    product?: Product
    parameter?: ProductParameter
    expansionSwitch?: (parameter: ProductParameter) => void
    expanded: boolean
    loading: boolean
    value?: ProductParameterValue[]
    valueChange: (value: string[], keepOpen: boolean) => void
    backToDefaultSettings: boolean
    resetSetBackToDefaultSettings: () => void
}

const ProductBuilderParamInputExpandable = (props: ProductBuilderParamInputProps) => {
    const [goToDefaultButton, setGoToDefaultButton] = useState(false)

    useEffect(() => {
        props.backToDefaultSettings && setGoToDefaultButton(true)
    }, [ props.backToDefaultSettings ]);

    useEffect(() => {
    }, [ props.expanded ]);

    const buttonActions = () => {
        props.resetSetBackToDefaultSettings()
        props.expansionSwitch(props.parameter)
        setGoToDefaultButton(false)
    }

    const classes = ButtonCustomStyles(props)
    const defaultDesignLabel = props.value.map(item => item.key).toString()
    const valueLabel = props.value && props.value.length ?
        props.value.map(it => it.label).join(', ')
        : undefined
    const valueChanged = props.parameter.changed
    return <Grid container justify='space-between' alignItems='center' wrap='nowrap' className={classes.root}>
        <Grid item>
            {valueLabel ? <b className={defaultDesignLabel === 'designDefaultLabel' ? 'default-label' : ''} >{valueLabel}</b> : <b className='default-label'>Please choose an option</b>}
        </Grid>
        <Grid item>
            <Button className={'ChangeButtonWidth ' + (props.expanded || valueChanged && !goToDefaultButton ? 'SecondaryButton' : '') } variant='contained' color={props.expanded || valueChanged && !goToDefaultButton ? 'secondary' : 'primary'} onClick={buttonActions} >
                {valueChanged ? 'Changed' : 'Change'}
                {!props.expanded && <ExpandMore className='button-label-icon' />}
                {props.expanded && <ExpandLess className='button-label-icon' />}
            </Button>
        </Grid>
    </Grid>
}

const ProductBuilderParamInputInteger = (props: ProductBuilderParamInputProps) => {
    const onChange = (event: ChangeEvent) => {
        const target: any = event.target
        const value = parseFloat(target.value)
        if (props.parameter.valueProvider.range.min != null && value < props.parameter.valueProvider.range.min) return
        else if (props.parameter.valueProvider.range.max != null && value > props.parameter.valueProvider.range.max) return
        else props.valueChange([target.value], false)
    }
    return <TextField
        type='number'
        value={props.parameter.key in props.product.configuration && props.product.configuration[props.parameter.key].length ? props.product.configuration[props.parameter.key][0].key : undefined}
        onChange={onChange}
        disabled={props.loading} />
}

const productBuilderParamInput = (props: ProductBuilderParamInputProps) => {
    switch (props.parameter.input) {
        case 'ImageBrowser': return <ProductBuilderParamInputExpandable {...props} />
        case 'IntegerField': return <ProductBuilderParamInputInteger {...props} />
        case 'ButtonBrowser': return <ProductBuilderParamInputExpandable {...props} />
        default: throw new Error(`Input ${props.parameter.input} is unsupported.`)
    }
}

export const ProductBuilderParamInput =
    connect((state: any) => state.productBuilderState)(productBuilderParamInput)
